<template>
  <div class="box">
    <div class="box-header">
      <custom :total="totals" />
    </div>

    <table class="table">
      <thead>
        <tr>
          <th class="is-xs">No.</th>
          <th class="is-md">Banner Position</th>
          <th>Preview</th>
          <th class="is-sxm">Click</th>
          <th class="is-sm">Publish</th>
          <th class="is-sm">Expire</th>
          <th class="is-sm">Setting</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(i, idx) in banners" :key="idx">
          <td>{{ idx + 1 }}</td>
          <td>{{ i.bannerTypes }}</td>

          <td>
            <div class="image-container">
              <img :src="i.image" alt="" />
            </div>
          </td>
          <td>{{ i.isClick }}</td>
          <td>{{ i.onlineDate | moment }}</td>
          <td>{{ i.closeDate | moment }}</td>
          <td>
            <div class="icon-group">
              <span
                @click="
                  $router.push({ name: 'add-banner', query: { id: i._id } })
                "
                ><i class="fad fa-cog"></i
              ></span>
              <span @click="deleteBanner(i._id)" class="alert"
                ><i class="fad fa-trash"></i
              ></span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import custom from "../Pagination/customPagination";
import { getBannersApi } from "@/apis/banner-api";

import moment from "moment";
import { DELETE_BANNER } from "@/graphql/banner/banner";
import { apolloClient } from "@/services/apollo-client";
export default {
  components: { custom },
  data: () => ({
    banners: [],
    totals: null,
    isLoading: false,
    form: {
      type: "all",
      page: 1,
      perPage: 10,
      search: "",
    },
  }),
  filters: {
    moment: function (date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
  methods: {
    async queryBanner() {
      this.isLoading = true;
      const { banners, totals } = await getBannersApi(this.form);
      this.banners = banners;
      this.totals = totals;
      this.isLoading = false;
    },
    async deleteBanner(i) {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      await apolloClient.mutate({
        mutation: DELETE_BANNER,
        variables: {
          bannerId: i,
        },
      });
      window.location.reload();
    },
  },
  watch: {
    // '$route.query.s'(val){
    //     if(val) {
    //      this.$router.push({ ...this.$route, query: { q: val } })
    //     }
    // },
    "$route.query": {
      handler() {
        //   this.queryBanner();
        this.form.type = this.$route.query.type;
        this.form.search = this.$route.query.s;
        this.form.page = parseInt(this.$route.query.q);
        this.form.perPage = parseInt(this.$route.query.p);
        this.queryBanner();
      },
      immediate: true,
      deep: true,
    },
  },
  //  created() {
  //     this.queryBanner()
  // }
};
</script>

<style lang="scss" scoped>
.image-container {
  height: 120px;
  width: auto;
  overflow: hidden;
  img {
    height: 120px;
    object-fit: cover;
  }
}
</style>